import { Settings } from 'react-slick';

export const THUMBS_SLIDER_CONFIG: Settings = {
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
  ],
};

export const NEW_THUMBS_SLIDER_CONFIG: Settings = {
  slidesToShow: 7,
  slidesToScroll: 7,
  responsive: [
    {
      breakpoint: 1250,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
      },
    },
  ],
};
